
import { defineComponent } from 'vue'

export default defineComponent({
    name: "widget-16",
    props: {
        widgetClasses: String,
        icon: String,
        title: String,
        subTitle: String,
        amount: Number,
    }
})
